import { StockGeneralService } from '../../../../Services/Product_Creation/stock-general.service';
import { Component, OnInit } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StockGeneralComponent } from '../stock-general/stock-general.component';
import { StockMetalComponent } from '../stock-metal/stock-metal.component';
import { StockStoneComponent } from '../stock-stone/stock-stone.component';
import { StockPackagingComponent } from '../stock-packaging/stock-packaging.component';
import { StockFeatureComponent } from '../stock-feature/stock-feature.component';
import { StockPriceComponent } from '../stock-price/stock-price.component';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { TabCommunicationService } from '../../../../Services/Stock-Tabs/tab-communication.service';
import Swal from 'sweetalert2';
import { SharedProductService } from '../../../../Services/Product_Creation/shared-product.service';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
  selector: 'app-product-creation',
  standalone: true,
  imports: [CommonModule, NgFor, FormsModule, StockGeneralComponent, StockMetalComponent, StockStoneComponent, StockPackagingComponent, StockPriceComponent, RouterLink],
  templateUrl: './product-creation.component.html',
  styleUrl: './product-creation.component.css'
})
export class ProductCreationComponent implements OnInit {
  router = inject(Router);

  // for list
  listTypes: string[] = ['General', 'categories'];
  selectedListType: string = '';

  // for stock tab
  activeTab = 0;

  tabs = [
    { id: 'general', label: 'General Details' },
    { id: 'metal', label: 'Silver Part Details' },
    { id: 'stone', label: 'Stone Details' },
    { id: 'packaging', label: 'Packaging Details' },
    // { id: 'feature', label: 'Add Feature Details' },
    { id: 'price', label: 'Price Details' },
  ];
  selectedOption: any;
  productId: any;
  productData: any;
  metalCompleted = false;
  stoneCompleted = false;
  packagingCompleted = false;



  constructor(
    private stockGeneralServiece: StockGeneralService,
    private tabCommService: TabCommunicationService,
    private route: ActivatedRoute,
    private sharedProductService: SharedProductService,
  ) { }

  ngOnInit(): void {
    this.sharedProductService.setProductId(null);
    localStorage.setItem('createdProductId', JSON.stringify(null));

    this.tabCommService.setActiveTab(0);

    // Subscribe to tab change from the service
    this.tabCommService.activeTabIndex$.subscribe((index: number) => {
      this.activeTab = index;
    });


    this.tabCommService.metalCompleted$.subscribe(status => {
      this.metalCompleted = status;
    });

    this.tabCommService.stoneCompleted$.subscribe(status => {
      this.stoneCompleted = status;
    });

    this.tabCommService.packagingCompleted$.subscribe(status => {
      this.packagingCompleted = status;
    });


  }

  isTabDisabled(tab: any): boolean {
    // Product must exist
    if (!this.isProductIdPresent && tab.id !== 'general') {
      return true;
    }

    // Stone locked until Metal
    if (tab.id === 'stone' && !this.metalCompleted) {
      return true;
    }

    // Packaging locked until Stone
    if (tab.id === 'packaging' && !this.stoneCompleted) {
      return true;
    }

    //  Price locked until Packaging
    if (tab.id === 'price' && !this.packagingCompleted) {
      return true;
    }

    return false;
  }



  selectTab(index: number) {
    const tab = this.tabs[index];

    if (this.isTabDisabled(tab)) {
      Swal.fire({
        icon: 'warning',
        title: 'Action not allowed',
        text:
          tab.id === 'stone'
            ? 'Please complete Silver Part Details first'
            : 'Please complete previous sections first',
        confirmButtonColor: '#c19725',
      });
      return;
    }

    this.activeTab = index;
    this.tabCommService.setActiveTab(index);
  }


  showRelatedList() {
    if (this.selectedListType === 'General') {
      this.router.navigate(['general-list']);
    } else if (this.selectedListType === 'categories') {
      this.router.navigate(['categories-list']);
    }
  }

  getProductId() {
    this.productId = localStorage.getItem('createdProductId');
    return this.productId ? JSON.parse(this.productId) : null;
  }

  get isProductIdPresent(): boolean {
    return this.getProductId() !== null;
  }

  discardProductId() {
    localStorage.setItem('createdProductId', JSON.stringify(null))
  }


  ifUserWantContinueWithOldData() {
    this.getStockGeneralDetails();

  }

  restoreDataMsg() {
    if (this.getProductId() !== null) {
      this.ifUserWantContinueWithOldData();
    }
  }

  goToCustomizeForm() {
    this.router.navigate(['/customize-form']);
  }

  isStoneDisabled(index: number): boolean {
    const stoneTabIndex = 2; // General=0, Metal=1, Stone=2
    return index === stoneTabIndex && !this.metalCompleted;
  }

  getStockGeneralDetails() {
    this.stockGeneralServiece.getProductById(localStorage.getItem('createdProductId')).subscribe((response: any) => {
      this.productData = response.data;
      console.log("hihihh", this.productData);

      Swal.fire({
        title: 'Data Restore?',
        html: `
          <p style="color: #c19725;"><b>Do you want to continue with : </b></p><br>
         <table style="width: 100%; color: black; border-collapse: collapse;">
            <tr>
              <td style="text-align: right; padding: 4px;"><b>Brandname :&nbsp;</b></td>
              <td style="text-align: left; padding: 4px;">${this.productData.brand_name}</td>
            </tr>
            <tr>
              <td style="text-align: right; padding: 4px;"><b>Barcode :&nbsp;</b></td>
              <td style="text-align: left; padding: 4px;">${this.productData.barcode}</td>
            </tr>
            <tr>
              <td style="text-align: right; padding: 4px;"><b>Product Group :&nbsp;</b></td>
              <td style="text-align: left; padding: 4px;">${this.productData.group}</td>
            </tr>
            <tr>
              <td style="text-align: right; padding: 4px;"><b>Product SKU :&nbsp;</b></td>
              <td style="text-align: left; padding: 4px;">${this.productData.unique_code_sku}</td>
            </tr>
         </table>

        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonText: '+ Create New Product',
        confirmButtonColor: '#c19725',
        cancelButtonColor: '#c19725',
        background: '#fff',
        color: '#000',
        customClass: {
          popup: 'auto-size-alert',
        },
      }).then((result) => {
        if (result.isConfirmed) {

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.discardProductId();


          const currentUrl = this.router.url;
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
          });
        }
      });
    })
  }
}


